import { render, staticRenderFns } from "./m_contacts.vue?vue&type=template&id=3dae6e08&scoped=true&"
import script from "./m_contacts.vue?vue&type=script&lang=js&"
export * from "./m_contacts.vue?vue&type=script&lang=js&"
import style0 from "./m_contacts.vue?vue&type=style&index=0&id=3dae6e08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dae6e08",
  null
  
)

export default component.exports